<template>

    <SubHeading :home="home" :tabs="tabs" :shorts="false" :currTab="currTab" @active="handleActive" />

    <!-- search layer -->
    <!-- <div class="grey lighten-4">
        <div class="container section"></div>
    </div> -->

  <!-- breadcrumbs -->
  <nav class="grey lighten-4 z-depth-0">
    <div class="container nav-wrapper">
      <div class="col s12">
        <router-link to="/" class="breadcrumb teal-text"><small> <i class="material-icons left">home</i> Dashboard</small></router-link>
        <span class="breadcrumb blue-grey-text pointable"><small>Benefits Home</small></span>
      </div>
    </div>
  </nav>

    <!-- Top -->
    <div id="top"></div>

    <div class="container">

        <LoadingDiv v-if="!isReady" />

        <div v-else>
            <br />
            <div class="section">
                <nav class="grey lighten-5 z-depth-0">
                    <div class="nav-wrapper">
                        <form>
                            <div class="input-field blue-text text-darken-2">
                                <input type="search" v-model="searchItem" placeholder="Search Benefits" />
                                <label class="label-icon" for="search"><i
                                        class="material-icons black-text">search</i></label>
                                <i class="material-icons white-text orange" @click="handleClearSearch"
                                    v-if="searchItem">clear</i>
                            </div>
                        </form>
                    </div>
                </nav>

                <!-- Loader -->
                <div class="progress" v-if="isLoading && isReady">
                    <div class="indeterminate"></div>
                </div>

                <!-- Auth -->
                <div class="card z-depth-0" v-for="benefit in benefits" :key="benefit.id">
                    <div class="card-content white">
                        <div class="row">
                            <div class="col s6">
                                <h6>
                                    {{ benefit.item }}
                                </h6>
                            </div>
                            <div class="col s6 secondary-content right-align">
                                <p class="chip">{{ benefit.description }}</p>
                            </div>
                        </div>
                    </div>

                    <br />
                </div>
            </div>
            <!-- No Auth Found -->
            <div class="section center" v-if="!benefits.length && !isLoading">
                <h6 class="chip">No Previous Authorization <em>found</em>...</h6>
            </div>


            <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
        </div>
    </div>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { ageSex } from "@/composables/fxLibrary/coreFx";
import getItemsOfItemsOfItems from "@/composables/getItemsOfItemsOfItems";
import SubHeading from "@/components/HeaderSubDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";

export default {
    name: "benefitsComponent",
    components: { SubHeading, LoadingDiv, PaginationDiv },
    setup() {
        const response = ref(null);
        const error = ref(false);
        const isReady = ref(false);
        const isLoading = ref(true);
        const searchItem = ref(null);
        const home = ref(null);
        const currUrl = ref(null);
        const currHook = ref(null);
        const currTab = ref(null);
        const tabs = ref([]);

        // vue router
        const router = useRouter();

        // store
        const store = useStore();

        // set for ids
        const planId = store.state?.user?.account?.plan_id;
        const clientId = store.state?.user?.account?.client_id;

        // start
        onMounted(() => {
            // page name
            document.title = "Benefits";
        });

        // menu
        onMounted(() => {
            // load tab
            tabs.value.push({ id: 1, name: "Your Benefits", title: "Home", icon: null, url: "benefits", hash: null, });

            // set default
            currTab.value = tabs.value.find(x => x.title.includes("Home"));
            // set home
            home.value = tabs.value.find(x => x.title.includes("Home"));
        });

        // starter
        onMounted(() => {
            // start
            getStarted();
        });

        // start
        const getStarted = () => {
            // set current Url
            currUrl.value = "benefits/plan/search";
            // set current Hook
            currHook.value = "?";
            // get items from function
            getItemsFromApi(currUrl.value, planId, clientId);
        }

        // handle curr status
        const handleActive = (tab) => {
            // refer
            if (tab.hash) {
                router.push({ name: tab.url, hash: tab.hash });
            } else {
                router.push({ name: tab.url });
            }
        };

        // get function
        const getItemsFromApi = (table, id1, id2) => {
            (async () => {
                const { res, err } = await getItemsOfItemsOfItems(table, id1, id2);

                if (res.value) {
                    response.value = res.value.data;

                } else {
                    error.value = err.value;
                }

                // Ready, Loading is complete
                isReady.value = true;
                isLoading.value = false;
            })();
        };

        // numbering
        const numberBadge = (num) => {
            return (
                (allPages.value.current_page - 1) * allPages.value.per_page + num + 1
            );
        };

        // ageSex
        const showAgeSex = (dob, sex) => {
            const { fx } = ageSex(dob, sex);
            return fx.value;
        };

        // switch page
        const handlePage = (page) => {
            // start laoding
            isReady.value = false;
            // go back up
            router.push({ hash: "#top" });
            // get new page items from function
            getItemsFromApi(
                currUrl.value, planId, `${clientId}${currHook.value}page=${page}`
            );
        };

        // search watcher
        watchEffect(() => {
            if (searchItem.value) {
                // start laoding
                isLoading.value = true;
                // set current Url
                currUrl.value = "benefits/plan/search";
                // set current Hook
                currHook.value = `?q=${searchItem.value}&`;
                // get searchItem items from function
                getItemsFromApi(currUrl.value, planId, `${clientId}?q=${searchItem.value}`);
            }
        });

        // restart
        const handleClearSearch = () => {
            // start laoding
            isLoading.value = true;
            // null search
            searchItem.value = null;
            // start
            getStarted();
        };

        // output results
        const benefits = computed(() => {
            if (!response.value) {
                return [];
            } else {
                return response.value.data;
            }
        });

        // output pages
        const allPages = computed(() => {
            if (!response.value) {
                return [];
            } else {
                return response.value; // get all
            }
        });

        return {
            handleActive,
            handlePage,
            showAgeSex,
            numberBadge,
            handleClearSearch,
            searchItem,
            home,
            currTab,
            tabs,
            error,
            isReady,
            isLoading,
            benefits,
            allPages,
        };
    },
};
</script>

<style scoped>
.progress {
  margin-top: -3px;
}
</style>
